export const PROCESSING = 'PROCESSING';
export const PROCESSING_EDITED = 'PROCESSING_EDITED';
export const PENDING = 'PENDING';
export const DEST_ACCEPTED = 'DEST_ACCEPTED';
export const SOURCE_ACCEPTED = 'SOURCE_ACCEPTED';
export const REJECTED = 'REJECTED';
export const EDITED = 'EDITED';
